// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'triangle-solid';

export const Component = () => (
  <path d='M24.522 23.6 12.26 2 0 23.6h24.521Zm-1.533-.958H1.533L12.26 3.964l10.728 18.678Zm1.533.958L12.26 2 0 23.6h24.521Z' />
);

export const viewBox = '0 0 25 25';
